import { render, staticRenderFns } from "./MyCustomAudioPlayer.vue?vue&type=template&id=3ea54434&scoped=true&"
import script from "./MyCustomAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./MyCustomAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MyCustomAudioPlayer.vue?vue&type=style&index=0&id=3ea54434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea54434",
  null
  
)

export default component.exports